import React from 'react';
import '../Styles/Services.css'; // Assuming you save the CSS in a file named Services.css
import { Link } from 'react-router-dom';
import ChatBot from "./ChatBot";

function Services() {
  return (
    <div className="services-section">
      <h2 style={{color:"blue", textAlign:'center'}}>Our Services</h2>
      <div className="services-container">
        <div className="service-box" data-aos="fade-up">
          <h3>Web Development</h3>
          <p>We help your career grow and blow to the world by creating user friendly portfolio websites.</p>
          <Link to={"/webdev"}>Read more &rarr;</Link>
        </div>
        <div className="service-box" data-aos="fade-up">
          <h3>Mobile App Development</h3>
          <p>We develop all kinds of mobile applications including personal diaries, health and fitness, ecommerce, etc.</p>
          <Link to={"/mobileapp"}>Read more &rarr;</Link>

        </div>
        <div className="service-box" data-aos="fade-up">
          <h3>Ecommerce Development</h3>
          <p>We help your business grow and blow to the world by creating user friendly and manageable ecommerce websites and systems ranging from small scale to large scale and multivendor.</p>
          <Link to={"/ecommerce"}>Read more &rarr;</Link>

        </div>
        <div className="service-box" data-aos="fade-up">
          <h3>School Management Systems</h3>
          <p>We develop school management systems for students marks analysis with staff panel, students panel and parents.</p>
          <Link to={"/school-systems"}>Read more &rarr;</Link>

        </div>
        <div className="service-box" data-aos="fade-up">
          <h3>Hospital Management Systems</h3>
          <p>We build hospital management systems and websites, as well as doctor appointment systems.</p>
          <Link to={"/hospital"}>Read more &rarr;</Link>

        </div>
        <div className="service-box" data-aos="fade-up">
          <h3>API Integrations</h3>
          <p>We help you connect your software with other applications to ensure seamless operation. Rest assured, we are here to make sure your systems communicate effectively with each other.</p>
          <Link to={"/intergrations"}>Read more &rarr;</Link>

        </div>
        <div className="service-box" data-aos="fade-up">
          <h3>Digital Marketing Websites</h3>
          <p>We leverage advanced technology to create powerful, user-friendly platforms that drive engagement and achieve your marketing goals. Let us help you establish a strong online presence with our customized digital marketing solutions.</p>
          <Link to={"/digital-marketing"}>Read more &rarr;</Link>

        </div>
      </div>
      <ChatBot />
    </div>
  );
}

export default Services;
